var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.07422 1.79687C1.07422 1.38698 1.40651 1.05469 1.81641 1.05469H18.1836C18.5935 1.05469 18.9258 1.38698 18.9258 1.79688V18.2031C18.9258 18.613 18.5935 18.9453 18.1836 18.9453H1.81641C1.40651 18.9453 1.07422 18.613 1.07422 18.2031V1.79687Z",
    fill: "#2A2A2D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.48047 2.46094V17.5391H17.5195V2.46094H2.48047ZM1.81641 1.05469C1.40651 1.05469 1.07422 1.38698 1.07422 1.79687V18.2031C1.07422 18.613 1.40651 18.9453 1.81641 18.9453H18.1836C18.5935 18.9453 18.9258 18.613 18.9258 18.2031V1.79688C18.9258 1.38698 18.5935 1.05469 18.1836 1.05469H1.81641Z",
    fill: "#BFBFBF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.48047 2.46094V17.5391H17.5195V2.46094H2.48047ZM1.81641 1.05469C1.40651 1.05469 1.07422 1.38698 1.07422 1.79687V18.2031C1.07422 18.613 1.40651 18.9453 1.81641 18.9453H18.1836C18.5935 18.9453 18.9258 18.613 18.9258 18.2031V1.79688C18.9258 1.38698 18.5935 1.05469 18.1836 1.05469H1.81641Z",
    fill: "#BFBFBF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.55469 13.3594V17.5391H11.4453V13.3594H8.55469ZM7.85156 11.9531C7.46324 11.9531 7.14844 12.2679 7.14844 12.6562V18.2422C7.14844 18.6305 7.46324 18.9453 7.85156 18.9453H12.1484C12.5368 18.9453 12.8516 18.6305 12.8516 18.2422V12.6562C12.8516 12.2679 12.5368 11.9531 12.1484 11.9531H7.85156Z",
    fill: "#BFBFBF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0.605469 5.37109C0.605469 4.98277 0.920269 4.66797 1.30859 4.66797H18.6914C19.0797 4.66797 19.3945 4.98277 19.3945 5.37109V9.43359C19.3945 9.82192 19.0797 10.1367 18.6914 10.1367H1.30859C0.920269 10.1367 0.605469 9.82192 0.605469 9.43359V5.37109Z",
    fill: "#2A2A2D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.01172 6.07422V8.73047H17.9883V6.07422H2.01172ZM1.30859 4.66797C0.920269 4.66797 0.605469 4.98277 0.605469 5.37109V9.43359C0.605469 9.82192 0.920269 10.1367 1.30859 10.1367H18.6914C19.0797 10.1367 19.3945 9.82192 19.3945 9.43359V5.37109C19.3945 4.98277 19.0797 4.66797 18.6914 4.66797H1.30859Z",
    fill: "#BFBFBF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShop);
export default __webpack_public_path__ + "static/media/shop.96c5809854aaa9e40b47bf6683d48662.svg";
export { ForwardRef as ReactComponent };